export const PRINTING_ATTRIBUTE = "data-printing";

/**
 * Printing lays the page out again at the sheet's width, where the side padding drops to zero; without the hold the
 * padding transition replays its return on screen. The first frame after `afterprint` restyles with the hold on.
 */
export const holdTransitionWhilePrinting = (element: HTMLElement, win: Window = window) => {
	let frame: number | null = null;

	const cancelRelease = () => {
		if (frame !== null) win.cancelAnimationFrame(frame);
		frame = null;
	};
	const hold = () => {
		cancelRelease();
		element.setAttribute(PRINTING_ATTRIBUTE, "");
	};
	const release = () => {
		cancelRelease();
		frame = win.requestAnimationFrame(() => {
			frame = win.requestAnimationFrame(() => {
				frame = null;
				element.removeAttribute(PRINTING_ATTRIBUTE);
			});
		});
	};

	win.addEventListener("beforeprint", hold);
	win.addEventListener("afterprint", release);
	return () => {
		win.removeEventListener("beforeprint", hold);
		win.removeEventListener("afterprint", release);
		cancelRelease();
		element.removeAttribute(PRINTING_ATTRIBUTE);
	};
};
